import React from 'react';
import './style.scss';
import {
  EventAvailableOutlined,
  EventBusyOutlined,
  EditCalendarOutlined,
  Circle,
} from '@mui/icons-material';

export const statusTypes = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  offline: 'offline',
  neutral: 'neutral',
} as const;

export type TStatus = (typeof statusTypes)[keyof typeof statusTypes];

const calendarMap = {
  success: <EventAvailableOutlined />,
  error: <EventBusyOutlined />,
  warning: <EditCalendarOutlined />,
  offline: <EventBusyOutlined />,
  neutral: <EventAvailableOutlined />,
};

const Status: React.FC<{
  status: TStatus;
  variant?: 'calendar' | 'circle' | 'text';
  children?: React.ReactNode;
}> = ({ status, variant = 'circle', children }) => {
  return (
    <span className={`status-component ${status} ${variant}`}>
      {variant === 'calendar' && calendarMap[status]}
      {variant === 'circle' && <Circle />}
      {variant === 'text' && children}
    </span>
  );
};

export default Status;
